import {
  IonButton,
  IonInput,
  IonLabel,
  IonTextarea,
  IonSelectOption,
  IonSelect,
} from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { getRTMEpisodes, SaveSetUpEpisode } from "../../services/AuthServices";
import { GetLatestSetUpEpisode } from "../../services/AuthServices";
import { SaveConsentForm } from "../../services/AuthServices";
import { SetUpEpisodeErrors } from "../../models/SetUpEpisodeForm";
import { PatientVM } from "../../models/PatientVM";

interface Episode {
  id: number;
  name: string;
}

interface Props {
  episodeName?: string;
  episodeDescription?: string;
  setSetupEpisode: Function;
  consentFormData?: any;
  onClose?: () => void;
  rtmStartDate?: string;
}

const SetupEpisodeModal: React.FC<Props> = ({
  setSetupEpisode,
  consentFormData,
  onClose,
  rtmStartDate,
}) => {
  const [episodeName, setEpisodeName] = useState("");
  // const [episodeDescription, setEpisodeDescription] = useState("");
  const [errors, setErrors] = useState<SetUpEpisodeErrors>({});
  const [displayValue, setDisplayValue] = useState(""); // For displaying in the field
  const [setUpEpisodeDetail, setsetUpEpisodeDetail] =
    useState<SetUpEpisodeErrors>({
      episodeName: "",
      episodeDescription: "",
    });
  const [patientDetails, setPatientDetails] = useState<PatientVM>(
    new PatientVM(),
  );
  const [episodeOptions, setEpisodeOptions] = useState<Episode[]>([]);

  const selectRef = useRef<HTMLIonSelectElement>(null);
  const [popoverWidth, setPopoverWidth] = useState<number>(250);

  const [selectedEpisodeId, setSelectedEpisodeId] = useState<number | null>(
    null,
  );
  const [isDropDown, setIsDropDown] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    debugger;
    console.log("Consent form data inside modal:", consentFormData);
    const fetchLatestSetupEpisode = async () => {
      try {
        var patientId = localStorage.getItem("patientServerID") || "";
        const response = await GetLatestSetUpEpisode({ patientId });
        debugger;
        const data = response?.data;

        if (data !== null && data !== undefined) {
          setEpisodeName(data?.episodeName || "");
          //setEpisodeDescription(data?.episodeDescription || "");

          if (episodeOptions.length > 0 && data?.episodeName) {
            const matchingEpisode = episodeOptions.find(
              (opt) => opt.name === data?.episodeName,
            );
            if (matchingEpisode) {
              console.log("Found matching episode:", matchingEpisode);
              setSelectedEpisodeId(matchingEpisode.id);
              setDisplayValue(
                `${matchingEpisode.name} - ${getCurrentDateString()}`,
              );
            }
          }
        } else {
          // No data: inputs remain empty
          setEpisodeName("");
          setSelectedEpisodeId(null);
          setDisplayValue("");
          //setEpisodeDescription("");
        }
      } catch (error) {
        console.error("Error fetching latest setup episode:", error);
        setEpisodeName("");
        setSelectedEpisodeId(null);
        setDisplayValue("");
        //setEpisodeDescription("");
      }
    };

    // Only fetch if episodeOptions are loaded
    if (episodeOptions.length > 0) {
      fetchLatestSetupEpisode();
    }
  }, [episodeOptions]); // runs once when the modal loads

  const saveEpisode = async (episodeId: number | null, name: string | null) => {
    try {
      const EncryptedServerId = localStorage.getItem("EncryptedServerId");

      // Prefer consentFormData timestamps (already computed with current time).
      // Fall back to rtmStartDate prop only when no consentFormData (e.g. opened from patient page).
      let localDateTimeToSend: string | null =
        consentFormData?.LocalDateTime || null;
      let utcDateTimeToSend: string | null =
        consentFormData?.UTCDateTime || null;

      if (!localDateTimeToSend && rtmStartDate) {
        // rtmStartDate prop may be a locale string like "5/14/2026" — combine with current time
        const now = new Date();
        const datePart = new Date(rtmStartDate);
        const year = datePart.getFullYear();
        const month = (datePart.getMonth() + 1).toString().padStart(2, "0");
        const day = datePart.getDate().toString().padStart(2, "0");
        const hour = now.getHours().toString().padStart(2, "0");
        const minute = now.getMinutes().toString().padStart(2, "0");
        const second = now.getSeconds().toString().padStart(2, "0");
        localDateTimeToSend = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

        const dateObj = new Date(localDateTimeToSend);
        const utcYear = dateObj.getUTCFullYear();
        const utcMonth = (dateObj.getUTCMonth() + 1)
          .toString()
          .padStart(2, "0");
        const utcDay = dateObj.getUTCDate().toString().padStart(2, "0");
        const utcHour = dateObj.getUTCHours().toString().padStart(2, "0");
        const utcMinute = dateObj.getUTCMinutes().toString().padStart(2, "0");
        const utcSecond = dateObj.getUTCSeconds().toString().padStart(2, "0");
        utcDateTimeToSend = `${utcYear}-${utcMonth}-${utcDay}T${utcHour}:${utcMinute}:${utcSecond}`;
      }

      const response = await SaveSetUpEpisode({
        episodeName: name,
        episodeId: episodeId,
        //episodeDescription: description,
        encryptedServerId: EncryptedServerId,
        patientId: localStorage.getItem("patientServerID") || "",
        masterUserId: localStorage.getItem("patientMasterID") || "",
        rtmId: 0,
        rtmStartDate: utcDateTimeToSend,
        LocalDateTime: localDateTimeToSend, // RTM start date in local time
        UTCDateTime: utcDateTimeToSend, // RTM start date in UTC
      });

      console.log("SaveSetUpEpisode response:", response);

      if (response?.data?.isResponseSuccessfull && response?.data?.id > 0) {
        setSetupEpisode(false);
        onClose?.(); // safe optional call
      }

      return response;
    } catch (error) {
      console.error("Error saving episode:", error);
      throw error; // optional: rethrow if you want to handle it higher up
    }
  };

  const handleConfirm = async () => {
    debugger;
    // const trimmedEpisodeName = episodeName.trim();
    // //const trimmedEpisodeDescription = episodeDescription.trim();
    // setEpisodeName(trimmedEpisodeName);
    // //setEpisodeDescription(trimmedEpisodeDescription);

    // if (!trimmedEpisodeName) {
    //   alert("Episode Name is required.");
    //   return;
    // }

    console.log("Selected Episode ID:", selectedEpisodeId);
    //console.log("Episode Description:", trimmedEpisodeDescription);

    if (consentFormData === null || consentFormData === undefined) {
      await saveEpisode(selectedEpisodeId, null); //trimmedEpisodeName, trimmedEpisodeDescription);
      return;
    }

    await SaveConsentForm({
      PatientId: consentFormData.PatientId,
      EncryptedServerId: consentFormData.EncryptedServerId,
      MobilePhone: consentFormData.MobilePhone,
      Email: consentFormData.Email,
      StartDate: consentFormData.StartDate,
      ExerciseStartTime:
        consentFormData.ExerciseStartTime === "NA"
          ? null
          : consentFormData.ExerciseStartTime,
      ExerciseStartTimeUtc:
        consentFormData.ExerciseStartTimeUtc === "NA"
          ? null
          : consentFormData.ExerciseStartTimeUtc,
      LocalDateTime: consentFormData.LocalDateTime, // RTM start date in local time
      UTCDateTime: consentFormData.UTCDateTime, // RTM start date in UTC
    }).then(async function (response: any) {
      console.log("Response: ", response);
      debugger;

      if (response.data.id > 0) {
        await saveEpisode(selectedEpisodeId, null); //trimmedEpisodeName, trimmedEpisodeDescription);

        setPatientDetails((prevState: PatientVM) => ({
          ...prevState,
          email: consentFormData.Email || "",
          phoneNumber: consentFormData.MobilePhone.replace(/-/g, "") || "",
        }));
      }
    });
  };

  const getCurrentDateString = () => {
    if (rtmStartDate) {
      return rtmStartDate;
    }
    const today = new Date();
    return today.toLocaleDateString("en-US"); // Format: MM/DD/YYYY
  };

  // Fetch episodes when component mounts
  useEffect(() => {
    debugger;
    const fetchEpisodes = async () => {
      try {
        const response = await getRTMEpisodes();
        // Assuming your API returns an array of episode names
        // Adjust if response structure is different
        if (response?.data) {
          setEpisodeOptions(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch episodes:", error);
      }
    };

    fetchEpisodes();
  }, []);

  useEffect(() => {
    if (selectRef.current) {
      const width = selectRef.current.getBoundingClientRect().width;
      document.documentElement.style.setProperty(
        "--select-width",
        `${width}px`,
      );
    }
  }, [episodeOptions]);

  // Also set width on mount and when component becomes visible
  useEffect(() => {
    const updateWidth = () => {
      if (selectRef.current) {
        const width = selectRef.current.getBoundingClientRect().width;
        if (width > 0) {
          // Only set if width is valid
          document.documentElement.style.setProperty(
            "--select-width",
            `${width}px`,
          );
        }
      }
    };

    // Initial width set
    updateWidth();

    // Optional: Update on resize
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target as Node)
      ) {
        setIsDropDown(false);
      }
    };

    if (isDropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropDown]);

  // Handle episode selection
  const handleEpisodeSelection = (option: { id: number; name: string }) => {
    debugger;
    console.log("Selected Episode ID:", option.id);

    setSelectedEpisodeId(option.id);
    setEpisodeName(option.name);
    // setDisplayValue(`${option.name} - ${getCurrentDateString()}`);
    setDisplayValue(`${option.name}`); // Display only the episode name in the field
    setIsDropDown(false); // Close dropdown after selection
  };

  return (
    <div className="setup-episode-modal-inner-wrap-sec">
      <h1 className="fz-32 fw-700 align-center text-charcoal-blue mb-16">
        Set up Episode
      </h1>
      <h1 className="fz-20 fw-400 align-center text-charcoal-blue mb-24">
        Add an episode to set the timeframe for the exercise care plan.
      </h1>
      <div className={`field-wrap ${errors?.episodeName && "error-wrap"}`}>
        {/* <div className="field-wrap"> */}
        <IonLabel className="label" placeholder={undefined}>
          Episode Name*
        </IonLabel>

        <div>
          <div ref={elementRef} className="select-wrap-sec">
            <div
              className="input-field"
              onClick={() => {
                setIsDropDown(!isDropDown);
              }}
            >
              {displayValue || "Select Episode"}
            </div>

            {isDropDown && (
              <div className="select-option-wrap selected">
                <ul>
                  {episodeOptions && episodeOptions.length > 0 ? (
                    episodeOptions.map((option) => {
                      return (
                        <li className="option-wrapper" key={option.id}>
                          <div
                            className="option-name"
                            onClick={() => {
                              handleEpisodeSelection(option);
                            }}
                          >
                            <span>{option.name}</span>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <li>No Episodes Found</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* <div style={{ width: "100%" }}>
          <IonSelect
            ref={selectRef}
            interface="popover"
            className="input-field"
            placeholder="Select Episode"
            value={selectedEpisodeId} // this will already include date
            selectedText={displayValue || undefined}
            onIonChange={(e) => {
              const id = e.detail.value!;

              console.log("Selected Episode ID:", id);

              setSelectedEpisodeId(id);
              const selectedEpisode = episodeOptions.find(
                (opt) => opt.id === id
              );
              if (selectedEpisode) {
                setEpisodeName(selectedEpisode.name);
                setDisplayValue(
                  `${selectedEpisode.name} - ${getCurrentDateString()}`
                );
              }
            }}
            interfaceOptions={{
              cssClass: "episode-popover",
              reference: "trigger", // Changed from "event" to "trigger"
              side: "bottom", // Position below the select
              alignment: "start", // Align to the start (left) of the select
            }}
          >
            {episodeOptions.map((option) => {
              return (
                <IonSelectOption
                  key={option.id}
                  value={option.id} // save the value with date
                  placeholder={undefined}
                >
                  {option.name}
                </IonSelectOption>
              );
            })}
          </IonSelect>
        </div> */}
      </div>

      <div className="two-col-btn">
        <IonButton
          placeholder={undefined}
          className="blue-outline-btn h-64 fz-26"
          onClick={() => setSetupEpisode(false)}
        >
          Cancel
        </IonButton>
        <IonButton
          placeholder={undefined}
          className="blue-btn h-64 fz-26"
          onClick={handleConfirm}
        >
          Confirm
        </IonButton>
      </div>
    </div>
  );
};

export default SetupEpisodeModal;
